import instance from "./auth";

export const getAllData = async (params) => {
    const {data} = await instance.get("/support/all", {
        params,
    });
    return data;
}
